import { getContext } from '@tetris/ad.js';
import bridge from 'libs/bridge';
import query from './query';
import { safeParse } from './utils';

interface AdInfo {
    extra?: any;
    reportEvent?: any;
    cid?: string;
}

// 是否是广告投放的页面
export const isAd = () => Number(query.page_id) > 0 || Number(query.origin_type) === 1;

export function getAdInfoFromBridge() {
    return new Promise((resolve, reject) => {
        // 先从本地获取ad信息，如果没有则从sdk和jsb获取
        if (query.getAdInfoLocal) {
            try {
                const json = JSON.parse(localStorage.getItem('LOCAL_AD_INFO') || '[]');
                resolve(json);
            } catch {
                reject(Error('get from localstorage fail'));
            }
        }
        setTimeout(() => reject(new Error('time out')), 1000);
        Promise.all([getContext(), bridge.call('adInfo')])
            .then((res) => resolve(res))
            .catch((err) => reject(err));
    });
}

export async function getAdInfoJson(): Promise<AdInfo> {
    return new Promise((resolve) => {
        let result = {};

        getAdInfoFromBridge()
            .then((res: any) => {
                let [context, ad] = res;
                // jsb中没有获取的cid，降级从url中获取

                if (!context.cid) {
                    throw new Error('未获取到aid');
                }
                result = {
                    ...context,
                    ad_extra_data: ad.ad_extra_data || ''
                };
            })
            .catch(() => {
                const entranceInfo = safeParse(decodeURIComponent(query.entrance_info));
                const cid = entranceInfo.creative_id;

                if (!cid) {
                    resolve(result);
                }

                result = {
                    log_extra: entranceInfo.log_extra,
                    cid: entranceInfo.creative_id,
                    ad_extra_data: entranceInfo.ad || ''
                };
            })
            .finally(() => {
                resolve(result);
            });
    });
}
